module.exports = __webpack_public_path__ + "static/img/dog-1.1e1030c7.png";